import React from 'react';
import styles from './styles.module.css';
import { DialogActions, Button, FormControl, InputLabel, Select, MenuItem, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Info from 'components/utils/Alert/Info';
import { useTranslation } from 'react-i18next';
import AccountServices from 'services/AccountServices';

function RefundTypePopup({ closeDialog, handleRefundType, subject, hidePaymentModeSelection = false }) {
  const { t: tCommon } = useTranslation('common');
  const { t: tPopup } = useTranslation('popup');

  const [accountHeads, setAccountHeads] = React.useState([]);
  const [selectedHeadId, setSelectedHeadId] = React.useState('');
  const [isProcessing, setIsProcessing] = React.useState(false);

  React.useEffect(() => {
    const fetchHeads = async () => {
      try {
        const data = await AccountServices.getAccountHeads({ is_enabled: true });
        // Filter account heads of type PAYMENT_MODE
        const paymentModes = (data || []).filter((h) => h.type === 'PAYMENT_MODE');
        setAccountHeads(paymentModes);
        // Default to Cash (or first element)
        const cashHead = paymentModes.find((h) => h.name.toLowerCase() === 'cash');
        if (cashHead) {
          setSelectedHeadId(cashHead.id);
        } else if (paymentModes.length > 0) {
          setSelectedHeadId(paymentModes[0].id);
        }
      } catch (err) {
        console.error('Failed to load account heads', err);
      }
    };
    fetchHeads();
  }, []);

  return (
    <div className={styles.popUp}>
      <div className={styles.contentWrapper}>
        <div className={styles.headSec}>
          <h2 className={styles.editTitle}>{tPopup('Select payment refund type')}</h2>
          <IconButton onClick={closeDialog} size='small'><CloseIcon /></IconButton>
        </div>
        <div className={styles.inputSec}>
          <h3 className={styles.inputSubLabel}>
            <Info
              title={tPopup('Payment Return Type')}
              content={tPopup(
                'How would you like to process the paid amount in this {{subject}}? You can choose between refunding the payment or keeping it in credit.',
                { subject }
              )}
              severity={'info'}
            />
          </h3>

          {!hidePaymentModeSelection && accountHeads.length > 0 && (
            <FormControl fullWidth variant="outlined" size="small" sx={{ mt: 2, mb: 1 }}>
              <InputLabel id="refund-method-label">{tPopup('Refund Method') || 'Refund Method'}</InputLabel>
              <Select
                labelId="refund-method-label"
                id="refund-method-select"
                value={selectedHeadId}
                label={tPopup('Refund Method') || 'Refund Method'}
                onChange={(e) => setSelectedHeadId(e.target.value)}
              >
                {accountHeads.map((head) => (
                  <MenuItem key={head.id} value={head.id}>
                    {head.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        </div>
        <div className={styles.footSec}>
          <DialogActions>
            <Button
              variant="contained"
              color="secondary"
              size="small"
              disabled={isProcessing}
              onClick={async () => {
                setIsProcessing(true);
                try {
                  await handleRefundType('refund', selectedHeadId);
                } finally {
                  setIsProcessing(false);
                }
              }}
              className={styles.closeBtn}
            >
              {tCommon('Refunded')}
            </Button>
            <Button
              variant="contained"
              size="small"
              disabled={isProcessing}
              sx={{ bgcolor: isProcessing ? undefined : '#00a65a', }}
              onClick={async () => {
                setIsProcessing(true);
                try {
                  await handleRefundType('credit');
                } finally {
                  setIsProcessing(false);
                }
              }}
            >
              {tCommon('Keep In Credit')}
            </Button>
          </DialogActions>
        </div>
      </div>
    </div>
  );
}

export default RefundTypePopup;
